import { filterByNotEmpty } from '../utils/menu';
import { getBankingMenu } from './bankingMenu';
import { getComplianceMenu } from './complianceMenu';
import { getDashboardMenu } from './dashboardMenu';
import { getDocumentsMenu } from './documentsMenu';
import { getEducationStudioMenu } from './educationStudioMenu';
import { getInsightsMenu } from './insightsMenu';
import { getMarketingToolsMenu } from './marketingToolsMenu';
import { getMoneyMenu } from './moneyMenu';
import { getMyBusinessMenu } from './myBusinessMenu';
import { getTaxServicesMenu } from './taxServicesMenu';
import { getWebToolsMenu } from './webToolsMenu';

/**
 * Get the menu config for the business entity.
 *
 * @param {{
 *  businessEntityUuid: string
 *  email: string
 *  entitlements: Set<string>
 * }} params
 *
 * @returns {Array}
 */
export function getMenuConfig(params) {
  if (!params.businessEntityUuid) {
    return [];
  }

  const menu = [
    getDashboardMenu(params),
    getBankingMenu(params),
    getMoneyMenu(params),
    getTaxServicesMenu(params),
    getWebToolsMenu(params),
    getMarketingToolsMenu(params),
    getEducationStudioMenu(params),
    getComplianceMenu(params),
    getDocumentsMenu(params),
    getMyBusinessMenu(params),
    getInsightsMenu(params)
  ];

  return menu.filter(filterByNotEmpty);
}
